<template>
    <div class="setting-page-content-wrapper features">
        <div class="page-header">
            <div class="title">{{ $t("message.websiteChatWidgetIntegration") }}</div>
            <div class="subtitle">{{ $t("settings.webSiteIntegrationSubtitles") }}</div>
        </div>
        <section>
            <div class="features">
                <InstallCode class="install-code" />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../components/FeatureItem.vue";
import InstallCode from "../../../../components/fast-initialize/InstallCode.vue";

const log = log2("Settings/WebSiteIntegration");

export default {
    name: "WebSiteIntegration",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
        InstallCode,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        readValue(id) {
            if (id === "writing") {
                return this.settings.writing == 1;
            } else {
                return this.settings[id];
            }
        },
        setValue(id, value) {
            // if (false) {
            // } else {
            this.updateSettings("id", value);
            // }
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped lang="scss">

.features {
    #install-code {
        width: 93% !important;
    }
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
